<template>
  <div class="option">
    <Head style="margin-bottom: -20px" ref="head" />
    <div class="main">
      <div class="bgImgBox">
        <div class="imgBoxCon">
          <span> {{ $fanyi("附加服务").toUpperCase() }}</span>
          <!-- 专业商品增值服务 -->
          <h1>
            {{ $fanyi("专业商品增值服务") }}
          </h1>
          <p>
            {{
              $fanyi(
                "在Rakumart，你还可以享受其他附加服务，如FBA贴标、产品摄影、ODM定制、翻译等。你有自己的私人品牌吗？太棒了，快联系我们吧！"
              )
            }}
          </p>
        </div>
        <div class="imgBoxCon"></div>
      </div>
      <!-- Servicios de producción de marca privada -->
      <div class="Services moudleP">
        <div class="ServicesH1">{{ $fanyi("为私人品牌提供定制化 OEM/ODM 服务。") }}</div>
        <div class="ServicesCon" style="padding-top: 30px">
          <div class="ServicesConImg">
            <img
              src="../../assets/newImg/footlist/fuJiaFuWu/produccion-oem-rakumart-1.jpg"
              alt=""
            />
          </div>
          <div class="ServicesConSpan">
            <div class="ConSpanH1">{{ $fanyi("为您的品牌提供定制化 OEM 生产") }}</div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "客户提出初步设计方案，我们将委托生产工厂将其实现，从而获得一款完全原创的产品。",
                )
              }}
            </div>
            <div class="spanBox" style="border-color: #ffa200">
              {{
                $fanyi("由于该流程从工厂采购材料开始，起订量与整体采购量通常会相应提高。")
              }}
            </div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "我们将与制造商确认起订量、单价、交货日期及工厂打样进度。"
                )
              }}
            </div>
            <div class="btnBox">
              <button @click="openChat">
                {{ $fanyi("如需更多信息，请联系业务代理。") }}
              </button>
            </div>
          </div>
        </div>
        <div class="ServicesCon">
          <div class="ServicesConSpan">
            <div class="ConSpanH1">{{ $fanyi("ODM生产服务") }}</div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "在现有产品上进行定制，添加客户所需的功能或特性，以通过其私人品牌进行销售。"
                )
              }}
            </div>
            <div class="spanBox" style="border-color: #ffa200">
              {{
                $fanyi("由于该流程从工厂采购材料开始，起订量与整体采购量通常会相应提高。")
              }}
            </div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "我们将与制造商确认起订量、单价、交货日期及工厂打样进度。"
                )
              }}
            </div>
            <div class="btnBox">
              <button @click="openChat">
                {{ $fanyi("如需更多信息，请联系业务代理。") }}
              </button>
            </div>
          </div>
          <div class="ServicesConImg">
            <img
              src="../../assets/newImg/footlist/fuJiaFuWu/produccion-odm-rakumart-1.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="ServicesCon">
          <div class="ServicesConImg">
            <img
              src="../../assets/newImg/footlist/fuJiaFuWu/produccion-packaging-personalizado-rakumart-2.jpg"
              alt=""
            />
          </div>
          <div class="ServicesConSpan">
            <div class="ConSpanH1">{{ $fanyi("包装、标签和宣传册") }}</div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "生产个性化包装、标签、包裹、宣传材料和您的私人品牌标志性元素。"
                )
              }}
            </div>
            <div class="spanBox" style="border-color: #ffa200">
              {{
                $fanyi(
                  "生产取决于所需的尺寸、颜色和材料类型。您需要提供所有品牌元素和信息，以便我们为您出具报价。"
                )
              }}
            </div>
            <div class="spanBox" style="border-color: #009246">
              {{
                $fanyi(
                  "请与我们的代理商咨询定制元素在产品组合中的组装和调整成本。"
                )
              }}
            </div>
            <div class="btnBox">
              <button @click="openChat">
                {{ $fanyi("如需更多信息，请联系业务代理。") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Servicios adicionales para tus productos -->
      <div class="productos moudleP">
        <div class="productosH1">{{ $fanyi("为您的产品提供额外服务") }}</div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img
              src="../../assets/newImg/footlist/fuJiaFuWu/servicio-adicional-de-fotografia-rakumart-2-300x300.png"
              alt=""
            />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("产品摄影") }}</h1>
            <p>
              {{ $fanyi("专业摄影服务，用于销售，无论商品的种类或复杂程度。") }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">1.04€ (7￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img
              src="../../assets/newImg/footlist/fuJiaFuWu/servicio-adicional-etiquetado-amazon-fba-rakumart-300x300.png"
              alt=""
            />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("SKU标签") }}</h1>
            <p>{{ $fanyi("带有SKU编码的标签放置") }}</p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i3.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("条形码标签") }}</h1>
            <p>{{ $fanyi("包括更换OPP塑料袋") }}</p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i4.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("更换OPP塑料袋") }}</h1>
            <p>{{ $fanyi("大件物品需单独报价") }}</p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.08€ (0.5￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i5.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("双面打印宣传页") }}</h1>
            <p>
              {{
                $fanyi(
                  "默认使用A4尺寸纸张，如需其他纸张类型或小册子打印，可根据要求提供。"
                )
              }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.3€ (2￥) per pezzo</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i6.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("织物标签缝制") }}</h1>
            <p>
              {{
                $fanyi("在纺织品如T恤、衬衫等上缝制带有您品牌的个性化标签。")
              }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i7.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("去除布料标签") }}</h1>
            <p>
              {{ $fanyi("我们去除了某些纺织品可能自工厂附带的布料标签。") }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.23€ (1.5￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i8.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("悬挂标签的放置【衣服吊牌】") }}</h1>
            <p>
              {{ $fanyi("在您需要的产品上悬挂带有您品牌的标签。") }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i9.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("去除吊牌") }}</h1>
            <p>
              {{ $fanyi("去除你所需产品上的工厂吊牌。") }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i10.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("组合包装") }}</h1>
            <p>
              {{ $fanyi("对于超过 4 件商品的配套增值服务，需另行询价") }}
            </p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
        <div class="productosOpt">
          <div class="productosOptImg">
            <img src="../../assets/newImg/footlist/fuJiaFuWu/i11.png" alt="" />
          </div>
          <div class="productosOptCon">
            <h1>{{ $fanyi("气泡膜包装保护服务") }}</h1>
            <p>{{ $fanyi("大尺寸/重型货物需申请特殊报价") }}</p>
          </div>
          <div class="productosOptPrice">
            <div class="pri">0.15€ (1￥)/pic</div>
            <button @click="openChat">{{ $fanyi("联系专属业务经理获取报价") }}</button>
          </div>
        </div>
      </div>
      <div class="expertAgent">
        <img
          class="expertAgentIcon"
          src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061517555044958.svg"
          alt=""
        />
        <div class="expertAgentCon">
          <h1>{{ $fanyi("您需要为您的产品定制特殊服务吗？") }}</h1>
          <p>
            {{
              $fanyi(
                "请告知我们您所需的服务类型及对应的产品，我们将为您提供全方位的定制化方案。",
              )
            }}
          </p>
          <button @click="openChat">
            {{ $fanyi("联系专属顾问") }}
          </button>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  methods: {
    openChat() {
      this.$fun.clickJs();
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  min-width: 1400px;
  background-color: white;
  padding-bottom: 1px;
  .moudleP {
    width: 1200px;
    margin: 0 auto;
    padding: 0 100px;
  }
  .bgImgBox {
    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260617145241730290.png");
    background-position: 50% 50%;
    background-size: 100% auto;
    height: 466.78px;
    display: flex;
    justify-content: center;
    align-items: center;
    .imgBoxCon {
      display: flex;
      width: 595px;
      padding: 10px;
      justify-content: center;
      flex-direction: column;
      span {
        color: #ffad00;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 1.5em;
        letter-spacing: 2px;
        margin-bottom: 32px;
        display: block;
      }
      h1 {
        color: #ffffff;
        font-size: 26px;
        font-weight: 600;
        line-height: 1.5em;
        margin-bottom: 20px;
      }
      p {
        text-align: left;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
      }
    }
  }
  .Services {
    .ServicesH1 {
      margin-top: 80px;
      line-height: 62px;
      font-size: 28px;
      font-weight: 400;
      text-align: center;
    }
    .ServicesCon {
      padding-top: 50px;
      padding-bottom: 80px;
      display: flex;
      justify-content: space-between;
      .ServicesConImg {
        width: 455px;
        height: 552.81px;

        img {
          width: 100%;
          border-radius: 15px;
          overflow: hidden;
          height: 100%;
        }
      }
      .ServicesConSpan {
        width: 475.44px;
        padding: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .ConSpanH1 {
          font-size: 21px;
          font-weight: 400;
          line-height: 31px;
          margin-bottom: 30px;
        }
        .spanBox {
          font-size: 16px;
          font-weight: 400;
          margin-bottom: 20px;
          line-height: 1.6em;
          border-left: solid 2px;
          padding-left: 20px;
        }
        .btnBox {
          padding-top: 20px;
          button {
            transition: 0.3s;
            border-style: solid;
            border-width: 1px;
            border-color: #009246;
            color: #009246;
            border-radius: 60px 60px 60px 60px;
            padding: 15px 50px 15px 50px;
            font-weight: 500;
            &:hover {
              color: #009246;
              background-color: #f1faef;
              border-color: #bddbb8;
            }
          }
        }
      }
    }
  }
  .productos {
    .productosH1 {
      text-align: center;
      margin-top: 30px;
      font-size: 28px;
      font-weight: 400;
      line-height: 1.5;
      color: #333;
      background-color: #fff;
    }
    .productosOpt {
      width: 820px;
      padding: 15px;
      margin: 30px auto;
      border-radius: 6px;
      border: #e3e3e3 solid 1px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
      display: flex;
      justify-content: center;
      align-items: center;
      .productosOptImg {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        box-sizing: content-box;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .productosOptCon {
        padding: 10px;
        flex: 1;
        h1 {
          font-size: 20px;
          font-weight: 500;
          line-height: 30px;
          margin-bottom: 5px;
        }
        p {
          margin-bottom: 14.4px;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .productosOptPrice {
        width: 272.88px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .pri {
          text-align: center;
          color: #656565;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 14.4px;
        }
        button {
          border-style: solid;
          border-width: 1px 1px 1px 1px;
          border-color: #cecece;
          border-radius: 8px;
          padding: 12px 30px 12px 30px;
          line-height: 14px;
          transition: 0.3s;
          color: #009246;
          font-weight: 500;

          &:hover {
            color: #009246;
            background: #f1faef;
            border-color: #009246;
          }
        }
      }
    }
  }
  .expertAgent {
    // height: 378.7px;
    width: 1200px;
    margin: 0 auto;
    background-color: #f8f9fa;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s;
    margin-top: 80px;
    margin-bottom: 80px;
    padding: 70px;
    .expertAgentIcon {
      width: 40px;
      height: 40px;
      display: block;
      margin: 0 auto 5.71px;
    }
    .expertAgentCon {
      width: 635px;
      padding: 10px;
      margin: 0 auto;
      > * {
        text-align: center;
      }
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      h1 {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.5em;
        margin-bottom: 5px;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
        margin-bottom: 20px;
      }
      button {
        font-size: 15px;
        line-height: 15px;
        font-weight: 600;
        width: 337px;
        height: 60px;
        padding: 20px 80px 20px 80px;
        border-radius: 12px;
        background: #009246;
        color: #fff;
      }
    }
  }
}
</style>
